import Vue from 'vue'
import Masker from '@/utils/masker'

Vue.directive('mask', {
  bind: function(el, binding) {
    const maskType = binding.value.replace(/(?:^|-)(\w)/g, (match, cg1) => cg1.toUpperCase())
    const maskFunction = Masker[`mask${maskType}`]
    if(!maskFunction) throw Error(`[DIRECTIVE V-MASK] There is no mask called ${binding.value}`)

    el.value = maskFunction(el.value)

    const inputHandler = function(e) {
      if (!e.isTrusted) return

      el.value = maskFunction(el.value)
      el.dispatchEvent(new Event('input'))
    }
    el.onblur = function(e) {
      e.target.value = maskFunction(e.target.value)
    }

    el.onkeydown = function(e) {
      if (!e.isTrusted) return

      if(['delete', 'backspace'].includes(e.key.toLocaleLowerCase())) {
        e.target.oninput = null
      } else {
        e.target.oninput = inputHandler
      }
    }


    el.oninput = inputHandler
  },
  componentUpdated: function(el, binding, vnode) {

    const maskType = binding.value.replace(/(?:^|-)(\w)/g, (match, cg1) => cg1.toUpperCase())
    const maskFunction = Masker[`mask${maskType}`]
    if(!maskFunction) throw Error(`[DIRECTIVE V-MASK] There is no mask called ${binding.value}`)
   
    const unmaskFunction = Masker[`unmask${maskType}`]
    if(!unmaskFunction) return
    // When the value is different the oninput is already taking care of it.
    if(unmaskFunction(vnode.elm.value) == unmaskFunction(el.value)) {
      el.value = maskFunction(el.value)
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/mask.js